import classNames from "classnames";
import { StatCardStarIllustration } from "../../AscIllustrations";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscStatCard.module.scss";
import coinsImage from "../../../assets/images/coins-image.png";
import AscImage from "../../AscImage/AscImage";
import { roundAndDropTrailingZeros } from "@ascendnow/shared";
export interface AscStatCardProps {
  className?: string;
  type: "coins" | "points";
  value: number;
  loading?: boolean;
}

export default function AscStatCard({
  type,
  value,
  className,
  loading = false,
}: AscStatCardProps) {
  return (
    <AscGenericCard
      title={null}
      loading={loading}
      coverImageUrl={null}
      data-testid="asc-stat-card"
      className={classNames(
        styles.ground,
        {
          [styles.coins]: type === "coins",
          [styles.points]: type === "points",
        },
        className
      )}
      contentClassName={styles.content}
      bodyClassName={styles.body}
    >
      <div className={styles.statTexts}>
        <div className={styles.value}>{roundAndDropTrailingZeros(value)}</div>
        <div className={styles.label}>
          {type === "coins" ? "Coins" : "Points"}
        </div>
      </div>
      {type === "coins" ? (
        <AscImage src={coinsImage} className={styles.icon} />
      ) : (
        <StatCardStarIllustration className={styles.icon} />
      )}
    </AscGenericCard>
  );
}
